import { useState, useEffect } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { API_URL } from '../config';
import './ItemDetail.css';

function ItemDetail() {
  const { name } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const [item, setItem] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetch(`${API_URL}/items/${name}`)
      .then(response => {
        if (!response.ok) {
          throw new Error('Failed to fetch item details');
        }
        return response.json();
      })
      .then(data => {
        setItem(data);
        setLoading(false);
      })
      .catch(error => {
        setError(error.message);
        setLoading(false);
      });
  }, [name]);

  const handleBack = () => {
    if (location.state?.from === 'competitive') {
      navigate('/competitive', { state: { scrollPosition: location.state.scrollPosition } });
    } else {
      navigate(-1);
    }
  };

  if (loading) return <div className="loading">Loading item details...</div>;
  if (error) return <div className="error">Error: {error}</div>;
  if (!item) return <div className="error">Item not found</div>;

  return (
    <div className="item-detail">
      <button onClick={handleBack} className="back-link">← Back</button>
      <div className="item-header">
        <div className="title-with-sprite">
          <img src={item.sprite} alt={item.name} className="item-sprite-large" />
          <h2>{item.name}</h2>
        </div>
        <span className="category-badge">{item.category}</span>
      </div>
      <div className="item-content">
        <div className="description-section">
          <h3>Description</h3>
          <p>{item.description}</p>
          <h4>Effect</h4>
          <p>{item.effect}</p>
        </div>
      </div>
    </div>
  );
}

export default ItemDetail; 